export const productConstants = {
  FETCH_PRODUCTS_LOADING: 'FETCH_PRODUCTS_LOADING',
  FETCH_PRODUCTS_SUCCESS: 'FETCH_PRODUCTS_SUCCESS',
  FETCH_PRODUCTS_FAIL: 'FETCH_PRODUCTS_FAIL',
};
